/// <amd-module name="Feed/Legacy/Protocols/PyPi/IPyPiProtocolMetadata" />

export interface IPyPiProtocolMetadata {
    description: string;
    descriptionContentType: string;
    author: string;
    authorEmail: string;
    maintainer: string;
    maintainerEmail: string;
    classifiers: string[];
}
